import { render, staticRenderFns } from "./h5page.vue?vue&type=template&id=f495531e&scoped=true&"
import script from "./h5page.vue?vue&type=script&lang=js&"
export * from "./h5page.vue?vue&type=script&lang=js&"
import style0 from "./h5page.vue?vue&type=style&index=0&id=f495531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f495531e",
  null
  
)

export default component.exports